export function normalizeFlagToBool(value) {
    if (value == null) return false
    const n = Number(value)
    if (!Number.isNaN(n)) return n === 1
    const s = String(value).trim().toLowerCase()
    return s === 'true' || s === '1' || s === 'yes'
}

